
import { defineComponent } from 'vue'
import { StringUtils } from '../../../utils'
import CopyToClipboard from '../../shared/copy-to-clipboard.component.vue'

export enum HtmlFormatEnum {
  LINK,
}

type SingleValueType = Date | object | string | number | boolean
type ValueType = SingleValueType[] | SingleValueType

export default defineComponent({
  name: 'AuditDetailsFieldValue',
  components: {
    CopyToClipboard,
  },
  props: {
    value: {
      type: [Array, Date, Object, String, Number, Boolean],
      default: '',
    },
    copyToClipboard: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    wrapperComponent() {
      return this.copyToClipboard ? CopyToClipboard : 'div'
    },
    component(): string {
      const componentsByFormat = {
        [HtmlFormatEnum.LINK]: 'a',
        default: 'span',
      }
      return componentsByFormat[this.detectedHtmlFormat] || componentsByFormat.default
    },
    componentProps(): Record<string, unknown> {
      return {
        [HtmlFormatEnum.LINK]: {
          href: this.valueText,
          title: this.valueText,
          target: '_blank',
        },
      }[this.detectedHtmlFormat]
    },
    detectedHtmlFormat(): HtmlFormatEnum {
      let detectedHtmlFormat: HtmlFormatEnum
      if (typeof this.value === 'string' && StringUtils.isLink(this.value)) {
        detectedHtmlFormat = HtmlFormatEnum.LINK
      }
      return detectedHtmlFormat
    },
    valueText(): string {
      return this.getValueText(this.value)
    },
  },
  methods: {
    getValueText(value: ValueType): string {
      if (Array.isArray(value)) {
        return value.map(this.getValueText).join(', ')
      }
      if (value instanceof Date) {
        return value.toLocaleDateString(this.$epb.locale, {
          hourCycle: 'h23',
          hour: '2-digit',
          minute: '2-digit',
        })
      }
      if (typeof value === 'object') {
        return JSON.stringify(value)
      }
      return value.toString()
    },
  },
})
